import {VALID_STATUSES, LOG_SKIPPED_STATUSES} from '@advisor/util/HttpStatus';

/**
 * @typedef {Object} Response
 * @property {String|Number} status
 *
 * @typedef {Object} HttpException
 * @property {Response} response
 *
 */

/**
 *
 * @param {Response} response
 */
export const returnNoneApi = (response) => {
  if (!VALID_STATUSES.includes(response.status)) {
    throw new Error(response);
  }

  return true;
};

/**
 * This function cheks if this error should be logged or not.
 *
 * @param {HttpException} error
 *
 * @returns {Boolean}
 */
export const shouldItLogged = (error) => {
  if (error.response.status && LOG_SKIPPED_STATUSES.includes(error.response.status)) {
    return false;
  }

  return true;
};
